import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import GestionarBaseDatos from "./configuracionGeneral/gestionBaseDatos";
import TablaUsuariosApp from "./configuracionGeneral/tablaUsuriosApp";
import TablaUsuarios from "./configuracionGeneral/tablaUsurios";
import TablaAfiliados from "./configuracionGeneral/tablaAfiliados";
import TablaPersonaAthos from "./configuracionGeneral/tablaPersonasAthos";
import GestionarScript from "./configuracionGeneral/gestionDataScript";
import GenerarBackup from "./configuracionGeneral/generarBackup";
import GestionarCp from "./configuracionGeneral/gestionCp";
import GenerarVersion from "./configuracionGeneral/generarVersion";

export const VerConfiguracionAthos = (props) => {
  const [mostrar, setMostrar] = useState(0);
  const [clase, setClase] = useState("d-flex bluex-bg");
  const [msg1, setMsg1] = useState("Gestionar Afiliados");

  const mostrarVis = (vista) => (e) => {
    e.preventDefault();
    setMostrar(vista);
  };

  const cancelar = () => {
    setMostrar("");
    setClase("d-flex bluex-bg");
    props.onHideCancela();
  };

  const menuclick = (titulo) => (e) => {
    e.preventDefault();
    setMsg1(titulo);
    if (clase === "d-flex bluex-bg") {
      setClase("d-flex bluex-bg toggled");
    } else {
      setClase("d-flex bluex-bg");
    }
  };

  const VISTA = {
    0: <TablaAfiliados menu={"sistema"} />,
    1: <TablaPersonaAthos />,
    2: <TablaUsuarios menu={"sistema"} />,
    3: <GestionarBaseDatos />,
    4: <TablaUsuariosApp menu={"sistema"} />,
    5: <GestionarScript />,
    6: <GenerarBackup menu={"sistema"} />,
    7: <GestionarCp menu={"sistema"} />,
    8: <GenerarVersion menu={"sistema"} />,
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Configuración General del SISTEMA</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <div
          className={clase}
          id="wrapper"
          style={{ overflow: "hidden", maxHeight: "85vh" }}
        >
          <div className="amanecergris " id="sidebar-wrapper">
            <div className="list-group list-group-flush ">
              <div className="list-group list-group-flush">
                <ul className="list-group list-group-light">
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Afiliados")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(0)}
                    >
                      <i className="  fas fa-sitemap fa-fw me-3 text-light px-2"></i>
                      <span className="text-dark text-secondary fw-bold">
                        Afiliados
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Personas")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(1)}
                    >
                      <i className="  fas fa-user-alt fa-fw me-3 text-primary px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Personas
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Usuarios")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(2)}
                    >
                      <i className="  fas fa-user-check fa-fw me-3 text-success px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Usuarios
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Usuarios App")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(4)}
                    >
                      <i className="  fas fa-user-check fa-fw me-3 text-success px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Usuarios App
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Bases De Datos")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(3)}
                    >
                      <i className="  fas fa-database fa-fw me-3 text-primary px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Bases de Datos
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Actualización")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(5)}
                    >
                      <i className="  fas fa-database fa-fw me-3 text-warning px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Ejecutar Script
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Generar Respaldo")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(6)}
                    >
                      <i className="  fas fa-database fa-fw me-3 text-success px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        Respaldar
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Copiar Directorio de Imagenes")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(7)}
                    >
                      <i className="  fas fa-database fa-fw me-3 text-success px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        CP
                      </span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Descargar Apk Athos")}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={mostrarVis(8)}
                    >
                      <i className="  fas fa-database fa-fw me-3 text-success px-2" />
                      <span className="text-dark text-secondary fw-bold">
                        APK
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div id="page-content-wrapper">
            <nav
              className="navbar navbar-expand-lg navbar-light py-2 px-2"
              id="one"
              style={{ background: "none" }}
            >
              <div className="d-flex align-items-center">
                <i
                  className="fas fa-align-left  text-dark fs-4 me-3"
                  onClick={menuclick(msg1)}
                  id="menu-toggle"
                />
              </div>
              <div
                className="collapse navbar-collapse dropstart"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mx-auto text-center">
                  <h4 className="fs-4">
                    {msg1 === "Gestion de Usuario Web" ? (
                      <i className="  fas fa-users-cog fa-lg px-2" />
                    ) : msg1 === "Estructura Organizativa" ? (
                      <i className="  fas fa-user-tie fa-lg px-2" />
                    ) : (
                      ""
                    )}
                    {msg1 === 0 ? "INICIO" : msg1}
                  </h4>
                </ul>
              </div>
            </nav>

            <div className="container-fluid mx-auto py-3" id="scrolty">
              {VISTA[mostrar]}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalVerConfiguracionAthos.js